import React, { useEffect } from "react";
import PropTypes from "prop-types";

var Tab = function Tab(_ref) {
  var children = _ref.children,
      title = _ref.title,
      index = _ref.index,
      onMountCallback = _ref.onMountCallback;

  useEffect(function () {
    if (onMountCallback) onMountCallback();
  }, []);

  return React.createElement(
    "div",
    { key: title + "-" + index },
    children
  );
};

Tab.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.string]).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  isTab: PropTypes.bool,
  title: PropTypes.string,
  index: PropTypes.number,
  onMountCallback: PropTypes.func
};

Tab.defaultProps = {
  isTab: true,
  title: undefined,
  index: undefined,
  onMountCallback: undefined
};

export default Tab;